import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { GoogleOAuthProvider } from '@react-oauth/google';

// TU ID ACTUALIZADO (Asegúrate que este sea el que está ACTIVO en Google Cloud)
const GOOGLE_CLIENT_ID = "524343647834-vb9jn0bh8eoovjvpeli3is3knspov832.apps.googleusercontent.com";

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
  <React.StrictMode>
    <GoogleOAuthProvider clientId={GOOGLE_CLIENT_ID}>
      <App />
    </GoogleOAuthProvider>
  </React.StrictMode>
);